import type { ReactNode } from 'react';
import Box, { BoxProps } from '@classify/react-core-components/Box';
import { SxProps, styled } from '@classify/react-core-components/styles';

export interface Props extends BoxProps {
  media?: ReactNode;
  children: ReactNode;
  isReverse?: boolean;
  sx?: SxProps;
}

const Content = styled(Box)({
  p: {
    maxInlineSize: 768,
  },
});

const Narrative = ({ media, children, isReverse, component, sx, className }: Props) => {
  const flexDirectionOverM = isReverse ? 'row-reverse' : 'row';

  return (
    <Box
      data-testid="narrative-root"
      display="flex"
      flexDirection={{ xs: 'column', md: flexDirectionOverM }}
      alignItems={{ md: 'center' }}
      gap={{ xs: 3, sm: 4, lg: 8 }}
      component={component}
      sx={{ ...sx }}
      className={className}
    >
      <Content flex={1}>{children}</Content>
      {media && media}
    </Box>
  );
};

export default Narrative;
